module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAH0lEQVQ4y2NgGBTglpDUf3SMDrCpGTVg1IBBZsDQBgDp4Y2GvVAy9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PE.png
// module id = 1237
// module chunks = 0